import { Form, Typography } from 'antd'
import React from 'react'
import { CommonClient } from '~/agents/common/client'
import { OnboardingValues } from '~/agents/salesAssistant/common'
import { ProviderAccountAuthorization } from '~/features/formConfiguration/client/components/CustomInputs/ProviderAccountAuthorization'
import { TitlePrimary } from '~/features/shared/components'
import { StepProps } from '../types'

type Props = StepProps

export const StepAuthorizations: React.FC<Props> = ({ ...props }) => {
  return (
    <>
      <CommonClient.Onboarding.Step {...props}>
        <TitlePrimary level={4}>Almost there</TitlePrimary>

        <Typography.Text type="secondary" className="mb-10">
          I just need you to grant me some permissions
        </Typography.Text>

        <Form.Item<OnboardingValues> shouldUpdate={true}>
          {options => {
            const providerAccountId = options.getFieldValue([
              'emailServices',
              'accountGmail',
            ])

            if (!providerAccountId) {
              return <></>
            }

            return (
              <>
                <Form.Item
                  name={['authorizations', 'modify']}
                  rules={[
                    {
                      validator: (_, value) =>
                        value?.[0]?.isCorrupted
                          ? Promise.reject()
                          : Promise.resolve(),
                      message: 'Authorization is not valid',
                    },
                  ]}
                >
                  <ProviderAccountAuthorization
                    providerAccountId={providerAccountId}
                    scope="https://www.googleapis.com/auth/gmail.modify"
                    ui={{
                      title: 'Manage Your Inbox',
                      iconAntd: 'GoogleOutlined',
                      description: 'Allow me to manage your inbox',
                    }}
                  />
                </Form.Item>

                <Form.Item
                  name={['authorizations', 'send']}
                  rules={[
                    {
                      validator: (_, value) =>
                        value?.[0]?.isCorrupted
                          ? Promise.reject()
                          : Promise.resolve(),
                      message: 'Authorization is not valid',
                    },
                  ]}
                >
                  <ProviderAccountAuthorization
                    providerAccountId={providerAccountId}
                    scope="https://www.googleapis.com/auth/gmail.send"
                    ui={{
                      title: 'Send Emails',
                      iconAntd: 'GoogleOutlined',
                      description: 'Allow me to send emails',
                    }}
                  />
                </Form.Item>
              </>
            )
          }}
        </Form.Item>
      </CommonClient.Onboarding.Step>
    </>
  )
}
